import { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import { formatDataTest } from '~/utils';

import styles from '../../section/Section.scss';

export const AddressDetails = memo(({ address, title }) => (
  <Fragment>
    <dt
      className={`${styles.Section__question_title} ${styles.Section__column}`}
      data-testid={formatDataTest(title, 'title')}
    >
      {title}
    </dt>
    <dd
      className={`${styles.Section__question_definition} ${styles.Section__column}`}
      data-testid={formatDataTest(title)}
    >
      <address>{address}</address>
    </dd>
  </Fragment>
));

AddressDetails.displayName = 'AddressDetails';

AddressDetails.propTypes = {
  title: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
};
